<ng-container *ngIf="(itemWithImageUrl$ | async) as item">
    <ng-container *ngIf="(imageCommentInputParam$ | async) as contentAttrParam">
        <div [ngClass]="(!!imageUrl) ? 'flex flex-column items-center justify-content-center text-center' : 'absolute left-15'">
            <div class="flex flex-row justify-content-center">
                <div class="flex justify-content-evenly">
                    <ng-container *ngIf="!!imageUrl">
                        <p-image [src]="imageUrl" [alt]="item.imageComment" width="70%"></p-image>
                    </ng-container>
                </div>
                <div class="flex flex-column justify-content-evenly">
                    <div class="flex items-center justify-content-center text-center" *ngIf="!contentAttrParam.attributeMetadata.read_only">
                        <p-fileUpload #fileUpload mode="basic" name="slika[]" (click)="clearFiles()" [customUpload]="true" accept="image/*"
                            [maxFileSize]="1000000" chooseLabel="Prenesi sliku" (onSelect)="selectFiles($event)"
                            uploadIcon="pi pi-trash" [showCancelButton]="true" [files]="uploadedFiles"></p-fileUpload>
                        <app-remove-image *ngIf="!!imageUrl"></app-remove-image>
                    </div>
                    <div class="flex items-center grid flex align-items-center items-center justify-content-center text-center m-4"
                        *ngIf="!contentAttrParam.attributeMetadata.read_only && !!imageUrl">
                        <label [for]="item.imageCommentFormControlName"
                            class="col-fixed block text-900 font-medium mb-2">{{contentAttrParam.attributeMetadata.description}}</label>
                        <ntap-prime-inputtextarea [inputParam]="contentAttrParam" class="col"></ntap-prime-inputtextarea>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>